import TeamPicker from './TeamPicker';

export default TeamPicker;
